import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';

const Services           = lazy(() => import('./pages/Services'));
const Projects            = lazy(() => import('./pages/Projects'));
const Sustainability      = lazy(() => import('./pages/Sustainability'));
const Gallery             = lazy(() => import('./pages/Gallery'));
const About               = lazy(() => import('./pages/About'));
const Contact             = lazy(() => import('./pages/Contact'));
const GetQuote            = lazy(() => import('./pages/GetQuote'));
const NotFound            = lazy(() => import('./pages/NotFound'));
const Admin               = lazy(() => import('./pages/Admin'));

const AppRoutes = () => (
  <Suspense fallback={null}>
    <Routes>
      <Route path="/"                  element={<Home />} />
      <Route path="/services"          element={<Services />} />
      <Route path="/projects"          element={<Projects />} />
      <Route path="/sustainability"    element={<Sustainability />} />
      <Route path="/gallery"           element={<Gallery />} />
      <Route path="/about"             element={<About />} />
      <Route path="/contact"           element={<Contact />} />
      <Route path="/get-quote"         element={<GetQuote />} />
      <Route path="/admin"             element={<Admin />} />
      <Route path="*"                  element={<NotFound />} />
    </Routes>
  </Suspense>
);

export default AppRoutes;
